module.exports = __webpack_public_path__ + "img/gear-K_88x88.36eaac9d.png";